A geographical coordinate.
